import { FunctionComponent } from 'react'
import { useArchiveLazyLoadingRule, useLazyLoadingRules } from '~/api/adm/lazy-loading-rules.api'
import { useScopePermissions } from '~/auth/useScopePermissions'
import { ArchivedRulesPage } from './ArchivedRulesPage'

/** The archived lazy loading rules. The page itself is shared with the other three kinds. */
export const ArchivedLazyLoadingRulesPage: FunctionComponent = () => {
  const { canArchive } = useScopePermissions()
  const { data: lazyLoadingRules, isLoading } = useLazyLoadingRules(false, true)
  const { mutateAsync: archiveLazyLoadingRule, isPending } = useArchiveLazyLoadingRule({
    successToast: 'Lazy loading rule unarchived',
    errorToast: 'Could not unarchive this lazy loading rule',
  })

  return (
    <ArchivedRulesPage
      rules={lazyLoadingRules}
      isLoading={isLoading}
      noun={'lazy loading rule'}
      backLabel={'Back to lazy loading rules'}
      backPath={'/monetization/one/lazy-loading'}
      onUnarchive={(rule) => archiveLazyLoadingRule({ id: rule.id, archived: false })}
      isUnarchiving={isPending}
      canUnarchive={canArchive}
      backTrackingLabel={'adm-lazy-loading-rules-archived-back-navigate'}
      unarchiveTrackingLabel={'adm-lazy-loading-rules-unarchive'}
    />
  )
}
